export enum StartDateErrorType {
  StartDateEmpty = 'start_date_empty',
  StartDateNotFuture = 'start_date_not_future'
}

export type StartDateError = {
  message: string;
  type: StartDateErrorType;
};

export type StartDateLockReason = 'None' | 'FeinShared';



// WEBPACK FOOTER //
// ./src/app/Classes/StartDate.ts